/*
This exports true if file is loaded in mac OS
 */
export default (() => {
  const platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  return macosPlatforms.indexOf(platform) > 0
})()
